// extracted by mini-css-extract-plugin
export default {"timerAlert":"TimerAlert_timerAlert__OGJW+"};